export enum AuthorizationStatus {
  PENDING = 'PENDING',
  VERIFIED = 'VERIFIED',
  AUTHORIZED = 'AUTHORIZED',
  DONE = 'DONE',
  FAILED = 'FAILED',
  EXPIRED = 'EXPIRED',
}

export const AUTHORIZATION_FLOW_EXPIRED_ERROR_KEY = 'authorization.expired';
export const AUTHORIZATION_PARENT_PERMISSION_REQUIRED = 'authorization.parentpermissionrequired';
